export default __webpack_public_path__ + "static/media/cm_6.69e64f58.png";